module.exports = __webpack_public_path__ + "static/media/barcode-light.b8a61ee6.svg";